import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns isSmallTablet boolean from page state
 * @return {boolean}
 */
export default function useIsSmallTablet() {
    return useAppSelector((state) => state?.page.isSmallTablet)
}